<template lang="pug">
component.slide(v-if="image", :is="tag", v-bind="props")
    .content-wrap(v-if="slide.title || slide.sub_title")
        .content
            h3.title(v-if="slide.title") {{ slide.title }}
            .sub-title(v-if="slide.sub_title") {{ slide.sub_title }}
    figure
        img(
            v-lazy="image",
            rel="noopener"
        )
</template>

<script>
import { get, trim } from '@/helpers';

export default {
    name: 'Slide',
    data() {
        return {
            delay: 0,
            mouseover: false
        };
    },
    props: {
        slide: {
            type: Object,
            required: true
        },
        maxWidth: {
            type: Number,
            required: true
        },
        maxHeight: {
            type: Number,
            required: true
        }
        // imageLoaded: {
        //     type: Boolean,
        //     default: false,
        // }
    },
    computed: {
        tag() {
            let tag = 'div';
            if (this.path) tag = 'router-link';
            else if (this.href) tag = 'a';
            return tag;
        },
        props() {
            let props = {};

            switch (this.tag) {
                case 'a':
                    props.href = this.href;
                    props.target = this.target;
                    break;

                case 'router-link':
                    props.to = this.path;
                    break;
            }

            return props;
        },
        image() {
            const image = get(this.slide, 'images.0');
            if (!image) return false;

            if (!this.maxWidth || !this.maxHeight) return false;

            let fit = get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1';
            const parameters = {
                ...get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups')
            };
            // let { w, h, fx, fy, fz } = parameters;
            let { fx, fy, fz } = parameters;

            let width, height, aspectRatio, devicePixelRatio, dprWidth, dprheight;
            aspectRatio = 16 / 9;

            if (!fx) fx = 0.5;
            if (!fy) fy = 0.5;
            if (!fz) fz = 1;

            // fit: cover

            width = this.maxWidth;
            height = width / aspectRatio;
            aspectRatio = width / height;

            devicePixelRatio = window.devicePixelRatio;

            dprWidth = width * devicePixelRatio;
            dprheight = height * devicePixelRatio;

            let format = '';
            if (this.webpSupport) format = '&format=webp';

            fit = `crop=focalpoint&x=${fx}&y=${fy}&z=${fz}&w=${dprWidth}&h=${dprheight}`;

            // TODO:
            // fit: contain

            const storageRoute = trim(
                `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}${format}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}${format}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}${format}&preview=blur`,
                width,
                height,
                aspectRatio
            };
        },
        width() {
            if (this.image.width) return Math.min(this.maxWidth, this.image.width);
            else return undefined;
        },
        height() {
            if (this.width && this.image.aspectRatio) return this.width / this.image.aspectRatio;
            else return undefined;
        }
    }
};
</script>

<style lang="sass" scoped>
.slide
    @apply relative
    .content-wrap
        @apply absolute w-full h-full flex flex-wrap content-center justify-end
        .content
            @apply text-white text-center p-4
            background-color: rgba(#000, 0.85)
            max-width: 300px
            .title
                @apply text-xl font-bold mb-2
figure
  img
      object-fit: cover
      object-position: center
      margin: 0 auto
</style>
